import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { uiActions, getSelectedMenu, getVisibleMenus } from '../../core/ui';

import { withRouter } from 'react-router';

import SelectionBar from './selection-bar';
import Export from '../export';

import ChartMenu from './chart-menu';
import GenerationMenu from './generation-menu';
import CellMenu from './cell-menu';

import { _Sidebar, _MenuBar, _ContentColumn } from './styled-sidebar';
import SelectedTab from './selected-tab';

import MenuButton from './menu-button';
import ChartIcon from 'react-icons/lib/md/album';
import GenerationIcon from 'react-icons/lib/md/panorama-fish-eye';
import CellIcon from 'react-icons/lib/md/person';
import PaletteIcon from 'react-icons/lib/md/palette';
import TemplateIcon from 'react-icons/lib/md/network-wifi';
import ImportIcon from 'react-icons/lib/md/group-add';
import AddOnsIcon from 'react-icons/lib/md/title';
import AdvancedIcon from 'react-icons/lib/md/build'
import ColorIcon from 'react-icons/lib/md/format-color-fill';

import PaletteMenu from './palette-menu';
import TemplateMenu from './template-menu';
import ImportMenu from './import-menu';
import AddOnsMenu from './add-ons-menu';
import SimpleMenu from './simple-menu';
import ColorMenu from './color-menu';

import AdvancedMenu from './palette-menu';

import { includes, findIndex, find, filter } from 'lodash';

class Sidebar extends React.Component {

  renderItemMenu(items, selectedIndex, colors) {
    const { setSelectedMenu } = this.props;

    return (
      <_MenuBar color={colors[0]}>
        <SelectedTab top={selectedIndex * 70} colors={colors} />
        {items.map((item, i) => (
          <MenuButton 
            {...item}
            selected={selectedIndex === i}
            onClick={() => setSelectedMenu(item.key)} 
            />
        ))}
      </_MenuBar>
    )
  }

  render() {
    const { visibleMenus, selectedMenu, setSelectedMenu } = this.props;

    if(!visibleMenus.length) {
      return null;
    }

    const colors = ['#262924', '#343631', '#43463f'];
    const menuItems = filter(allMenuItems, item => includes(visibleMenus, item.key));
    
    const selected = find(menuItems, item => item.key === selectedMenu) || menuItems[0];
    
    const primary = find(menuItems, item => item.key === selected.parent) || selected;
    const primaryItems = filter(menuItems, item => !item.parent);
    const primaryIndex = findIndex(primaryItems, item => item.key === primary.key);

    
    const secondaryItems = filter(menuItems, item => item.parent === primary.key);
    const secondary = find(secondaryItems, item => item.key === selected.key) || secondaryItems[0];
    const secondaryIndex = findIndex(secondaryItems, item => item.key === secondary.key);


    const primaryColors = [colors[0], colors[secondary ? 1 : 2]];

    const MenuComponent = secondary ? secondary.component : primary.component;

    return (
      <_Sidebar>
        {this.renderItemMenu(primaryItems, primaryIndex, primaryColors)}
        {secondary && this.renderItemMenu(secondaryItems, secondaryIndex, colors.slice(1))}
        <_ContentColumn>
          <MenuComponent />
        </_ContentColumn>
      </_Sidebar>
    )
  }
}

const mapStateToProps = createSelector(
  getSelectedMenu,
  getVisibleMenus,
  (selectedMenu, visibleMenus) => ({
    selectedMenu,
    visibleMenus,
  })
)

const mapDispatchToProps = Object.assign({}, uiActions)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar));

const allMenuItems = [
  {text: "chart", key: "simple", icon: <ChartIcon />, component: SimpleMenu},
  {text: "decal", key: "decal", icon: <AddOnsIcon />, component: AddOnsMenu},
  {text: "import names", key: "import", icon: <ImportIcon />, component: ImportMenu},
  {text: "advanced", key: "advanced", icon: <AdvancedIcon />},
  {text: "individual", key: "individual", parent: 'advanced', icon: <CellIcon />, component: CellMenu},
  {text: "generation", key: "generation", parent: 'advanced', icon: <GenerationIcon />, component: GenerationMenu},
  {text: "chart", key: "chart", parent: 'advanced', icon: <ChartIcon />, component: ChartMenu},
  {text: "color", key: "color", parent: 'advanced', icon: <ColorIcon />, component: ColorMenu},
  {text: "shape", key: "template", parent: 'advanced', icon: <TemplateIcon />, component: TemplateMenu},
  {text: "palette", key: "palette", parent: 'advanced', icon: <PaletteIcon />, component: PaletteMenu},
]


// WEBPACK FOOTER //
// ./src/components/menu/index.js